import React, { useContext, type ReactNode } from "react";

const context = React.createContext({
  lat: "0",
  lng: "0",
});

export function LocationContextProvider({
  lat,
  lng,
  children,
}: {
  children: ReactNode;
  lat: string;
  lng: string;
}) {
  return <context.Provider value={{ lat, lng }}>{children}</context.Provider>;
}

export function useLocationContext() {
  return useContext(context);
}
